import { gsap, ScrollTrigger } from '../global/gsap';

const initRelatedLinks = (el) => {
    const parentContainer = el.parentNode;
    const trigger = el.querySelector('.js-related-trigger');
    const content = el.querySelector('.js-related-content');

    let mm = gsap.matchMedia();

    mm.add('(max-width: 899px)', () => {
        let drawerOpen = false;

        // Drawer Toggle Logic
        const toggleDrawer = (open) => {
            gsap.to(content, {
                height: open ? 'auto' : 0,
                duration: 0.4,
                ease: 'power2.inOut'
            });
            el.classList.toggle('is-active', open);
        };

        // Visibility Logic
        const showLinks = (show) => {
            gsap.to(el, {
                autoAlpha: show ? 1 : 0,
                duration: 0.3
            });
        };

        // ScrollTrigger Logic
        const showTl = ScrollTrigger.create({
            trigger: parentContainer,
            start: 'top bottom',
            end: 'bottom bottom',
            onLeave: () => showLinks(false),
            onEnterBack: () => showLinks(true),
        });

        const handleTriggerClick = () => {
            drawerOpen = !drawerOpen;
            toggleDrawer(drawerOpen);
        };

        trigger.addEventListener('click', handleTriggerClick);

        return () => {
            trigger.removeEventListener('click', handleTriggerClick);
            gsap.set([el, content], { clearProps: 'all' });
            el.classList.remove('is-active');
        };
    });
};

export default initRelatedLinks;
